import React, {  Component } from 'react';
import classes from './Header.module.css';
import {connect} from 'react-redux';
import logo from '../../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faHeart, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import noUserPic from '../../assets/no_user.jpg';
import axios from 'axios';
import {Link} from 'react-router-dom';
import Notification from '../../containers/Notification/Notification';
import firebase from '../../firebase';
class Header extends Component {

    state = {
      user: {},
      modal: {
        isShow: false
      },
      newNotification: false,
      newMessage: 0
    }

    componentDidMount() {
      axios.get('/users/' + 
      this.props.loginStatus.userId + '.json?auth=' + this.props.loginStatus.authToken)
      .then(response => {
          this.setState({user: response.data});
      });

      firebase.database().ref('users/' + this.props.loginStatus.userId + '/notifications')
      .on('value', (snapShot)=>{
        let value= false;
        if(!snapShot.val()[snapShot.val().length-1].isRead) {
          value = true; 
        }
        this.setState({newNotification: value});
     });

     firebase.database().ref('messages/' + this.props.loginStatus.userId)
     .on('value', (snapShot)=>{
       let count = 0;
       Object.keys(snapShot.val()).map(userId => {
        if(!snapShot.val()[userId][snapShot.val()[userId].length-1].status) {
          count ++;
        }
        this.setState({newMessage: count});
       })
     });
    }
    
    toggleNotificationModal = () => {
      this.setState({modal:{isShow: !this.state.modal.isShow}})
    }
   
    render() {
    return(
        <header>
        <div className={classes.header}>
            <nav>
                <div className={classes.navContainer}>
                  <div className={classes.logo}>
                  <Link to="/">
                    <img src={logo}  alt="fakeinsta logo"/>
                    </Link>
                  </div>
                  <div className={classes.navLinks}>
                    <ul>
                      <li>
                        <Link to="/">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  id={classes.homeicon} className={classes.icon}>
                          <path d="M 12 2.0996094 L 1 12 L 4 12 L 4 21 L 10 21 L 10 15 L 14 15 L 14 21 L 20 21 L 20 12 L 23 12 L 12 2.0996094 z"/>
                        </svg>
                        </Link>
                      </li>
                      <li>
                      <Link to="/messages">
                        <FontAwesomeIcon icon={faEnvelope} className={classes.icon} style={{paddingBottom: '2px'}} />
                        {this.state.newMessage !== 0 ?
                        <span className={classes.new}>{this.state.newMessage}</span>:null
                        }
                        </Link>
                      </li>
                      <li>
                        <Link to="/explore">
                        <FontAwesomeIcon icon={faSearch}  className={classes.icon} style={{paddingBottom: '2px'}}/>
                        </Link>
                      </li>
                      <li>
                        <FontAwesomeIcon icon={faHeart} className={classes.icon} onClick={this.toggleNotificationModal} 
                        style={{cursor:'pointer'}}/>
                        {this.state.newNotification ?
                        <span className={classes.new +' '+ classes.notify}>1</span>:null
                        }
                        {this.state.modal.isShow ?
                          <Notification close={this.toggleNotificationModal}/>
                          :null
                        }
                      </li>
                      <li>
                      <Link to="/profile">
                       <img src={this.state.user.profilePic !== undefined ? 
                       this.state.user.profilePic : noUserPic} alt="profile pic" id={classes.userIcon}/>
                       </Link>
                      </li>
                    </ul>
                  </div>
                </div>
            </nav>
        </div>
      </header>
    )
  }
}

const mapStateToProps = state => {
  return {
      loginStatus: state.loginStatus
  }
}

export default connect(mapStateToProps)(Header);